module.exports = __webpack_public_path__ + "img/Group 1421.08023d18.svg";